import React from 'react';
import {Markdown} from "../../core";

export default function SGMarkdownPage() {

    return <div>
        <Markdown placeholder="Markdown Editor"/>

    </div>
}